// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  firebaseClient: {
    apiKey: "AIzaSyCj1VeQ4t-tXXszmRiNyZQyOKHu-F0CQr0",
    authDomain: "pandor-201115.firebaseapp.com",
    databaseURL: "https://pandor-201115.firebaseio.com",
    projectId: "pandor-201115",
    storageBucket: "pandor-201115.appspot.com",
    messagingSenderId: "716900956031"
  },
  firebaseTrader: {
    apiKey: "AIzaSyCUBJ-x2daR3OX5z-KRNomYCStoSR522Dg",
    authDomain: "peerless-tiger-185321.firebaseapp.com",
    databaseURL: "https://peerless-tiger-185321.firebaseio.com",
    projectId: "peerless-tiger-185321",
    storageBucket: "peerless-tiger-185321.appspot.com",
    messagingSenderId: "155160320063"
  },

  ////////////////////////////// mode dev local ///////////////////////////////
  // production: false,
  // apiUrl: "http://localhost:8080/v1/",
  // apiUrlSlim: "http://localhost:8080/v2/",
  // version: "debug",
  // emulator: true,
  // stripe: {
  //   stripePublicKey: 'pk_test_izmudHU0KuWXJkWONUxJLXfj',
  // },
  /////////////////////////////////////////////////////////////////////////////

  ///////////////////////////// mode dev en ligne /////////////////////////////
  production: false,
  apiUrl: "https://webshopapi.dev.aws.fulleapps.io/v1/",
  apiUrlSlim: "https://webshopapi.dev.aws.fulleapps.io/v2/",
  version: "debug",
  emulator: true,
  stripe: {
    stripePublicKey: 'pk_test_izmudHU0KuWXJkWONUxJLXfj',
  },
  /////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////// mode prod /////////////////////////////////
  // production: true,
  // apiUrl: "https://webshopapi.prod.aws.fulleapps.io/v1/",
  // apiUrlSlim: "https://webshopapi.prod.aws.fulleapps.io/v2/",
  // version: "388",
  // stripe: {
  //   stripePublicKey: 'pk_live_3v8GuJXBWmqMdtaCdHCPmFQ4',
  // },
  /////////////////////////////////////////////////////////////////////////////

  tinyUrl: {
    tinyurlApiKey: 'c8wSOpD81m6O6n5GlwBEUixxrAqOHscM6aOJuS2BvQM8ku8HYJNbw0Ydt9is',
    tinyurlUrl: 'https://api.tinyurl.com/create',
  },
};
